import { SET_VALUES_ADMIN, CLEAR_VALUES_ADMIN } from '@constants/actionType'

const initialState = {
  user: null,
  profileSelect: [],
  isAllCountriesVisible: false,
  optionCountriesVisible: []
};

function admin(state = initialState, actions) {
  switch (actions.type) {
    case SET_VALUES_ADMIN:
      return { ...state, ...actions.payload };
    case CLEAR_VALUES_ADMIN:
      return {
        user: null,
        profileSelect: [],
        isAllCountriesVisible: false,
        optionCountriesVisible: []
      };
    default:
      return state;
  }
}

export default admin;
